var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_10836)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265 118C145.154 118 48 215.057 48 334.783V672H196.685V316.536C196.685 278.845 227.271 248.29 265 248.29C302.729 248.29 333.315 278.845 333.315 316.536V672H482V334.783C482 215.057 384.846 118 265 118Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 318.243C198 280.553 228.221 250 265.5 250C302.779 250 333 280.553 333 318.243V451H198V318.243Z",
    fill: "#D9D9D9",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.784 -125.309C373.186 81.0639 291.21 150.847 253.672 159.941L291.226 196.702C356.397 193.387 397.312 159.426 409.623 142.86C449.258 120.049 427.129 104.988 411.109 100.309C467.995 84.0107 455.11 68.3342 441.558 62.5332C467.38 46.0043 447.623 27.87 434.517 20.8689C465.188 4.52805 447.536 -15.9595 434.876 -24.1606L400.784 -125.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.187 159.875C291.702 150.729 373.772 81.1531 401.93 -123.989L435.685 -23.5815C448.305 -15.469 465.874 4.83747 435.196 21.1631C448.265 28.0819 467.944 46.0441 442.108 62.5426C455.626 68.2676 468.448 83.8074 411.59 100.166C427.575 104.769 449.632 119.671 409.983 142.451C382.685 160.194 354.413 182.803 291.586 196.294",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.5,
    cy: 309,
    rx: 31.5,
    ry: 23,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 293C254.556 296.307 276.533 307.338 288 325",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 293C278.444 296.307 256.467 307.338 245 325",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.32 157.041L126.27 60.837L140.66 135.537L117.504 141.339L196.655 242.867L178.347 162.301L201.32 157.041Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.763 258.723L17 288.175L76.8588 298.127L74.7768 317.055L172.659 286.012L107.327 277.364L109.763 258.723Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.641 263.475C507.767 272.241 479.217 286.571 452 273.767",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.405 214.808C432.582 205.272 438.33 183.626 451.898 173.333",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.961 192.153C523.166 209.426 495.227 221.502 477.975 204.25C474.179 199.59 468.339 186.487 477.975 180.233C483.227 178 489.907 176.697 498.945 190.449C511.126 212.847 495.06 244.965 443.192 243",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_10836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/일반외과_항문낭 질환.5c103e16910ddcf42be67691d213253c.svg";
export { ForwardRef as ReactComponent };